import React, { useEffect } from "react";
import Button from "../../components/common/button/Button";
import SubHeader from "../../components/header/SubHeader";
import { useDispatch, useSelector } from "react-redux";
import { getTableColumns, getTableData } from "../../models/branchSubscriptionModel"; // changed to globalProductModel
import Table from "../../components/common/table/Table";
import ActionDropdown from "../../components/actions/ActionDropdown";
import { resetCreateStatus, resetUpdateStatus } from "../../store/branch-subscription-slice";
import {fetchBranchSubscription} from "../../store/branch-subscription-slice";
import { useSearchParams } from 'react-router-dom';

const BranchSubscriptionView = () => {
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const {
        items,
        fetchStatus,
        createStatus,
        updateStatus,
        pagination,
        error
    } = useSelector(state => state.globalSubscription);

    //set initial page and limit
    const initialPage = Number(searchParams.get("page")) || 1;
    const initialLimit = Number(searchParams.get("limit")) || 25;

    useEffect(() => {
        dispatch(fetchBranchSubscription({page: initialPage, limit: initialLimit}));
    }, [dispatch, initialPage, initialLimit]);

    useEffect(() => {
        if (createStatus === "success") {
            dispatch(resetCreateStatus());
        }
    }, [dispatch, createStatus]);

    useEffect(() => {
        if (updateStatus === "success") {
            dispatch(resetUpdateStatus());
        }
    }, [dispatch, updateStatus]);


    const tableColumns = getTableColumns({ ActionDropdown });
    const tableData = getTableData({ items });
    return (
        <>
            <SubHeader title="Branches with subscription">
                <Button to="add" className="btn-sm bg-primary bg-opacity-50">Add New</Button>
            </SubHeader>
            {fetchStatus === "loading" && <p>Loading...</p>}
            {fetchStatus === "failed" && <h6 className="text-danger">{error}</h6>}
            {fetchStatus === "success" && <Table className="mobile-responsive" columns={tableColumns} data={tableData} pagination={pagination} />}
        </>
    );
};

export default BranchSubscriptionView;
